const Vue = require('vue');
const Vuex = require('vuex');

Vue.use(Vuex);

const utils = {
    wrap: function(_options) {
        let options = JSON.parse(JSON.stringify(_options));
        if (options.method == 'GET') {
            if (!options.params) {
                options.params = {};
            }
        }
        return new Promise(resolve => {
            // utils.loading.open();
            axios(options).then(function(response) {
                if (response.data.code == 403) {
                    alert(response.data.message);
                    location.href = '/login';
                } else {
                    resolve(response.data);
                }
            }).catch(options.error).finally(function () {
                // utils.loading.close();
            });
        });
    },
    merge: function(objects) {
        let _merge = {};
        for (let i = 0; i < objects.length; i++) {
            _merge = _.merge(_merge, objects[i]);
        }
        return _merge;
    }
};

const store = new Vuex.Store({
    state: {
        language_pack: {}
    },
    actions: {
        'LANGUAGE': function(context, language) {
            return utils.wrap({method: 'GET', url: `/ajax/resource/language/${language}`}).then(function(data) {
                context.state.language_pack = data.pack;
                return data;
            });
        },
    }
});

export default store;
